export default {"src":"/_webapp/_next/static/media/500InternalServerError.7ab71b14.svg","height":184,"width":113,"blurWidth":0,"blurHeight":0};